'use client';

import { useFormStatus } from 'react-dom';

interface SubmitButtonProps {
  defaultText: string;
  pendingText: string;
}

export function SubmitButton({ defaultText, pendingText }: SubmitButtonProps) {
  const { pending } = useFormStatus();

  return (
    <button
      type={pending ? 'button' : 'submit'}
      aria-disabled={pending}
      className="flex h-[32px] w-full items-center justify-center rounded-[2px] border border-black bg-black text-white hover:bg-black/90 transition-colors disabled:opacity-50 disabled:cursor-not-allowed text-[13px] leading-[13px] uppercase tracking-[0.39px] font-normal"
      style={{ fontFamily: 'var(--font-founders-grotesk-text), "Test Founders Grotesk Text", "Founders Grotesk Text", sans-serif' }}
    >
      {pending ? pendingText : defaultText}
      {pending && (
        <svg
          className="animate-spin ml-2 h-3.5 w-3.5 text-white"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
          />
        </svg>
      )}
      <span aria-live="polite" className="sr-only" role="status">
        {pending ? pendingText : defaultText}
      </span>
    </button>
  );
}
